import { Link } from 'react-router-dom';
import { UpscalerApp } from './UpscalerApp';
import { Seo } from './Seo';
import { FaqBlock } from './FaqBlock';
import {
  softwareApplicationSchema,
  faqSchema,
  breadcrumbsSchema,
  websiteSchema,
  organizationSchema,
} from '../lib/schema';
import type { PageDef } from '../lib/config';
import type { ReactNode } from 'react';

export function ToolPageShell({
  page,
  faqItems,
  extraContent,
  hideApp = false,
}: {
  page: PageDef;
  faqItems: { question: string; answer: string }[];
  extraContent?: ReactNode;
  hideApp?: boolean;
}) {
  return (
    <>
      <Seo
        page={page}
        schemas={[
          websiteSchema(),
          organizationSchema(),
          softwareApplicationSchema(),
          faqSchema(faqItems),
          breadcrumbsSchema(page),
        ]}
      />
      <section className="bg-gradient-to-b from-primary-50/10 to-bg-base px-4 pb-16 pt-12 text-center sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <h1 className="text-4xl font-extrabold tracking-tight text-text-primary sm:text-5xl">
            {page.h1}
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-text-secondary">{page.subhead}</p>
          {!hideApp && (
            <div className="mt-8">
              <UpscalerApp uploadLabel={page.uploadLabel} />
            </div>
          )}
        </div>
      </section>

      {extraContent && (
        <section className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
              <div className="prose prose-invert mx-auto max-w-none">{extraContent}</div>
        </section>
      )}

      <section className="bg-bg-elevated px-4 py-16 text-center text-white sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold">{page.uploadLabel}</h2>
        <Link
          to={page.path}
          className="mt-6 inline-block rounded-full bg-primary px-8 py-3 font-semibold text-white hover:bg-primary-hover"
        >
          {page.uploadLabel}
        </Link>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <h2 className="text-center text-2xl font-bold text-text-primary">Frequently asked questions</h2>
        <div className="mt-8">
          <FaqBlock items={faqItems} />
        </div>
      </section>
    </>
  );
}
